import { BaseModel } from "../Generics/BaseModel"

export class SelectionOptionStockEntity extends BaseModel {
  genericFoodEntityId: number

  selectionOptionEntityId: number

  hasStockControl: boolean

  stockQuantity: number

  constructor(data: Partial<SelectionOptionStockEntity> = {}) {
    super()

    this.genericFoodEntityId = data.genericFoodEntityId ?? -1

    this.selectionOptionEntityId = data.selectionOptionEntityId ?? -1

    this.hasStockControl = data.hasStockControl ?? false

    this.stockQuantity = data.stockQuantity ?? 0
  }

  get isOutOfStock(): boolean {
    return this.hasStockControl && this.stockQuantity <= 0
  }
}
